import React from "react";
import DupontButton from "../components/DupontButton";
import { useTranslation } from "react-i18next";
import { ValueStrings } from "../utils/constantsString";
import { DuPontTMLogo } from "../assets/icons";

import "./index.scss";

const NotAuthorized = () => {
  const { t } = useTranslation();
  const handleButtonClick = () => {
    window.open(ValueStrings.contactUsPageLink, "_blank");
  };

  return (
    <>
      <div className="unautorized-user">
        <div className="d-flex margin-auto">
          <span className="unautorized-user--icon" />
          <div className="unautorized-user__info">
            <div className="unauthorized-logo-container">
              <DuPontTMLogo width="120" height="35" />
              <span className="unauth-water-solutions">
                {t("unAuthorized.waterSolutions")}
              </span>
            </div>

            <div className="unautorized-user__info--text">
              <label className="title">{t("unAuthorized.welcomeTo")}</label>
              <div>
                <span className="desalitec-logo--heading">
                  {t("unAuthorized.advisor")}
                </span>
              </div>
              <div className="message">
                {t("unAuthorized.noPermission")}
                <span>{t("unAuthorized.advisor")}</span> <br /> <br />
                <DupontButton type={"secondary"} onClick={handleButtonClick}>
                  Contact Us
                </DupontButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotAuthorized;
